var map = {
	"./Cabeza, vista dorsal.png": 23,
	"./Cabeza, vista lateral derecha.png": 1649,
	"./Cabeza, vista lateral izquierda.png": 5476,
	"./Cabeza, vista ventral.png": 2450,
	"./Cuello, vista dorsal.png": 7591,
	"./Cuello, vista ventral.png": 2377,
	"./Dermograma.png": 6592,
	"./Hipocondrio derecho.png": 6074,
	"./Hipocondrio izquierdo.png": 3829,
	"./Miembro anterior derecho, vista dorsal.png": 8459,
	"./Miembro anterior derecho, vista ventral.png": 2315,
	"./Miembro anterior izquierdo, vista dorsal.png": 2609,
	"./Miembro anterior izquierdo, vista ventral.png": 343,
	"./Miembro posterior derecho, vista dorsal.png": 5040,
	"./Miembro posterior derecho, vista ventral.png": 6642,
	"./Miembro posterior izquierdo, vista dorsal.png": 5653,
	"./Miembro posterior izquierdo, vista ventral.png": 5244,
	"./Región inguinal derecha.png": 5608,
	"./Región inguinal izquierda.png": 1213,
	"./Región lateral - Flanco derecho.png": 6902,
	"./Región lateral - Flanco izquierdo.png": 9939,
	"./Región púbica.png": 3803,
	"./Región umbilical.png": 3942,
	"./Región xifoidea.png": 8750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1102;